(function () {
    'use strict';

    angular
        .module('app.interestingCountry', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.interestingCountry', {
                    requireLogin: true,
                    url: 'admin/interestingCountry',
                    templateUrl: 'app/admin/influencerManagement/interestingCountry/interestingCountry.html?app_v=deployDate',
                    controller: 'interestingCountryCtrl',
                    scope: {},
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'interestingCountry']
                    },
                    params: {
                        
                    }
                });
        }]);
})();